import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./LibraryLessonCardMiddle.module.scss";
import {CardIconType} from "../../../models/view/common/ICard";
import {LibraryLessonCardDifficulty} from "../library-lesson-card-difficulty/LibraryLessonCardDifficulty";
import {CardIcon} from "../card-icon/CardIcon";

export interface ILibraryLessonCardMiddleProps {
  title: string;
  subTitle?: string;
  difficultyName?: string;
  icon?: CardIconType;
  onClick?: () => void;
}

export const LibraryLessonCardMiddle: VoidFunctionComponent<ILibraryLessonCardMiddleProps> = ({title, subTitle, icon, difficultyName, onClick}) => {
  return (
    <div className={s.cardMiddle} onClick={onClick}>
      <LibraryLessonCardDifficulty useClassName={s.difficulty} name={difficultyName} />
      <div className={s.title}>{title}</div>
      <div className={s.subTitle}>{subTitle}</div>
      <CardIcon icon={icon} />
    </div>
  );
}

